<template>
  <div>
    <van-nav-bar title="销假申请" left-text="返回" right-text="" @click-left="onClickLeft"/>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="销假说明" name="1" icon="calendar-o">
        <div style="color: red" v-html="this.tips"></div>
      </van-collapse-item>
    </van-collapse>
    <van-form class="login-form-top">

      <van-radio-group v-model="selectHolidayId">
        <van-cell-group>
          <van-cell :title="holidayApplyTitle(item)" clickable v-for="item in holidayApplyList" :key="item.id"
                    clickable @click="holidayApplyRecord(item)">
            <template slot="right-icon">
              <van-radio :name="item.id" @click="holidayApplyRecord(item)"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <van-field
        readonly
        clickable
        name="beginTime"
        :value="beginTime"
        label="开始时间"
        placeholder="点击选择日期"
        :rules="[{ required: true, message: '请选择开始时间' }]"
        @click="showBeginCalendar = showCalendarStatus"
      />
      <van-calendar :show-confirm="false" v-model="showBeginCalendar" @confirm="onBeginConfirm"
                    :min-date="minDate" :max-date="maxDate"/>
      <van-field
        readonly
        clickable
        name="endTime"
        :value="endTime"
        label="结束时间"
        placeholder="点击选择日期"
        :rules="[{ required: true, message: '请选择结束时间' }]"
        @click="showEndCalendar = showCalendarStatus"
      />
      <van-calendar :show-confirm="false" v-model="showEndCalendar" @confirm="onEndConfirm"
                    :min-date="minDate" :max-date="maxDate"/>

      <van-field
        v-model="reason"
        rows="3"
        autosize
        label="原因"
        type="textarea"
        maxlength="50"
        placeholder="请填写原因"
        show-word-limit
      />
      <van-field name="applyFile" label="附件">
        <template slot="input">
          <van-uploader :before-read="beforeApplyFileRead" :after-read="afterApplyFileRead"
                        :max-size="5000 * 1024" max-count="6" v-model="showFiles" multiple
                        :before-delete="beforeApplyFileDelete"
                        accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
          </van-uploader>
        </template>
      </van-field>

    </van-form>
<!--    <div style="margin: 16px;">-->
<!--      <van-button round block type="primary" native-type="submit" @click="taskSave">保存</van-button>-->
<!--    </div>-->
    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="taskSubmit">提交</van-button>
    </div>

    <van-dialog v-model="roleShow" title="我的角色" show-cancel-button @confirm="roleCommit" confirmButtonText="提交">
      <van-radio-group v-model="roleRadio">
        <van-cell-group>
          <van-cell :title="item.roleName" clickable v-for="item in roleList" :key="item.roleAlias"
                    clickable @click="roleRadio = item.roleAlias">
            <template slot="right-icon">
              <van-radio :name="item.roleAlias"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
    <ProcessDialog ref="showProcessDialog" :submitFlowMethod="submitFlowMethod" :getFlowParamsMethod="getFlowParamsMethod"/>
  </div>
</template>

<script>

import {Dialog, Toast} from "vant";
import Vue from "vue";
import moment from "moment";
import {isLogin, isWechat, replaceUrl} from "../../../utils/util";

export default {
  name: "holidayCancelForm",
  data() {
    return {
      modelKey: "holidayCancel",
      activeNames: ['1'],
      taskId: '',
      processInstanceId: '',
      processDefinitionId: '',
      appNo: '',
      holidayApplyList: [],
      showBeginCalendar: false,
      beginTime: '',
      showEndCalendar: false,
      endTime: '',
      selectHolidayId: 0,
      childRule: {},
      showCalendarStatus: true,
      applyHoliday: {},
      realName: '',
      deptName: '',
      userInfo: {},
      holidayCancelId: null,
      choseRoleId: '',
      nextProcess: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2099, 0, 31),
      reason: '',
      showFiles: [],
      allFiles: {
        applyFiles: [],
        removedFiles: [],
      },
      applyFileIds: [],
      workYear: 0,
      roleShow: false,
      roleRadio: 0,
      roleList: [],
      pageType: 0,
      processShow: false,
      tips: '',
    };
  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.appNo = this.$route.query.appNo;
    this.processInstanceId = this.$route.query.processInstanceId;
    this.taskId = this.$route.query.taskId;
    this.processDefinitionId = this.$route.query.processDefinitionId;
    this.userOutCityId = this.$route.query.userOutCityId;
    this.pageType = this.$route.query.pageType;
    this.initUserInfo();
  },
  methods: {
    initUserInfo() {
      this.getUserInfo();
    },
    getUserInfo() {
      this.$fetch("/attence-api/blade-user/info", {}).then(
        res => {
          const user = res.data;
          this.realName = user.realName;
          this.deptName = user.deptName;
          this.userInfo = user;
          this.workYear = user.workYear;
          this.dictionaryInit();
        }
      );
    },
    holidayApplyTitle(item) {
      let title = '假期类型：' + item.ruleName + "，开始时间：" + item.beginTime + "，结束时间：" + item.endTime
        + "，请假天数：" + item.day + "，申请时间：" + item.createTime;
      return title;
    },
    getInitData() {
      //如果当前流程已数据
      this.$fetch("/attence-api/blade-holiday-cancel/holidayCancel/flowDetailByFlowAppNo", {
        flowAppNo: this.appNo,
      }).then(res => {
        const data = res.data;
        if (data.id != undefined) {
          this.holidayCancelId = data.id;
          this.beginTime = data.beginTime;
          this.endTime = data.endTime;
          this.reason = data.reason;
          this.selectHolidayId = data.leaveId;
          this.allFiles = data.allFiles;
          this.showFiles = data.allFiles.applyFiles;
          this.showFiles.forEach(v => {
            this.applyFileIds.push(v.id);
            v.url = replaceUrl(v.viewUrl);
          });
        }
        const _this = this;
        this.$fetch("/attence-api/blade-holiday-leave/holidayleave/getMyHolidayApplyList", {}).then(res => {
          const data = res.data;
          data.forEach(function (column) {
            if (column.id == _this.selectHolidayId) {

            }
          });
          _this.holidayApplyList = data;
        });
      });
    },
    dictionaryInit() {
      this.getInitData();
      this.$fetch("/attence-api/blade-system/param/getSystemParam", {
        key: 'HOLIDAY_CANCEL_PROMPT'
      }).then(res => {
        const data = res.data;
        if (data != null) {
          this.tips = data;
        }
      });
    },
    onBeginConfirm(date) {
      if (this.selectHolidayId == 0) {
        Toast('请选择一条请假记录！');
      } else {
        this.beginTime = moment(date).format("YYYY-MM-DD");
        const choseBeginTime = new Date(this.beginTime + ' 00:00:00');
        const applyBeginTime = new Date(this.applyHoliday.beginTime + ' 00:00:00');
        const applyEndTime = new Date(this.applyHoliday.endTime + ' 00:00:00');
        if (choseBeginTime.getTime() < applyBeginTime.getTime()) {
          Toast('销假开始时间不能小于请假开始时间！');
          this.beginTime = '';
        }

        if (choseBeginTime.getTime() > applyEndTime.getTime()) {
          Toast('销假开始时间不能大于请假结束时间！');
          this.beginTime = '';
        }
      }
      this.endTime = '';
      this.showBeginCalendar = false;
    },
    onEndConfirm(date) {
      if (this.beginTime == '') {
        Toast('请先选择开始时间');
      } else {
        this.endTime = moment(date).format("YYYY-MM-DD");
        const choseBeginTime = new Date(this.beginTime + ' 00:00:00');
        const applyBeginTime = new Date(this.applyHoliday.beginTime + ' 00:00:00');
        const choseEndTime = new Date(this.endTime + ' 00:00:00');
        const applyEndTime = new Date(this.applyHoliday.endTime + ' 00:00:00');
        if (choseEndTime.getTime() < choseBeginTime.getTime()) {
          Toast('销假结束时间不能小于销假开始时间！');
          this.endTime = '';
        }

        if (choseEndTime.getTime() > applyEndTime.getTime()) {
          Toast('销假结束时间不能大于请假结束时间！');
          this.endTime = '';
        }

        if (this.childRule.isMiddleCancel == 0) {//不允许中间销假
          //销假选择的开始时间跟请假的开始时间和结束时间都不相等
          if (choseBeginTime.getTime() != applyBeginTime.getTime() && choseBeginTime.getTime() != applyEndTime.getTime()) {
            //销假选择的结束时间跟请假的结束时间不相等
            if (choseEndTime.getTime() != applyEndTime.getTime()) {
              Toast('当前请假不允许中间时间段销假，请重新选择时间！');
              this.beginTime = '';
              this.endTime = '';
            }
          }
        }
      }

      this.showEndCalendar = false;
    },
    onClickLeft: function () {
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/holidayCancel/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    holidayApplyRecord(item) {
      this.showCalendarStatus = true;
      this.applyHoliday = item;
      this.selectHolidayId = item.id;
      this.$fetch("/attence-api/blade-holiday-rule/holidayrule/detail", {
        id: item.ruleSubId
      }).then(res => {
        const data = res.data;
        this.childRule = data;
        this.beginTime = item.beginTime;
        this.endTime = item.endTime;
        if (this.applyHoliday.day == 1) {//请假天数为1天，选中后自动获取开始结束时间
          this.showCalendarStatus = false;
        } else {
          if (this.childRule.isPartCancel == 0) {//不允许部分销假
            this.showCalendarStatus = false;
          }
        }
      });
    },
    // 返回布尔值
    beforeApplyFileRead(file) {
      return true;
    },
    afterApplyFileRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizColumn', 'applyFiles');
      this.$filePost("/attence-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.applyFileIds.push(data.id);
          this.allFiles.applyFiles.push(data);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeApplyFileDelete(file, detail) {
      let index = JSON.stringify(detail.index);
      let delId = this.applyFileIds[index];
      let url = "/attence-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.applyFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.applyFileIds);
        },
        error => {
        }
      );
      return true;
    },
    taskSave() {
      if (this.beginTime == '') {
        Toast('请选择开始时间');
        return;
      }

      if (this.endTime == '') {
        Toast('请选择结束时间');
        return;
      }

      if (this.reason == '') {
        Toast('请填写原因');
        return;
      }


      const params = {
        id: this.holidayCancelId,
        beginTime: this.beginTime,
        endTime: this.endTime,
        leaveId: this.selectHolidayId,
        reason: this.reason,
        allFiles: this.allFiles,
        appNo: this.appNo,
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
      };
      //流程参数
      params.flow = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
      };
      params.selectedRole = this.choseRoleId;
      this.$bodyPost("/attence-api/blade-holiday-cancel/holidayCancel/submit", params).then(resp => {
        Toast("数据保存成功");
        this.$router.push({
          path: "/attenceflow/holidayCancel/list",
          query: {}
        });
      }, error => {

      });
    },
    taskSubmit() {
      if (this.beginTime == '') {
        Toast('请选择开始时间');
        return;
      }

      if (this.endTime == '') {
        Toast('请选择结束时间');
        return;
      }

      if (this.reason == '') {
        Toast('请填写原因');
        return;
      }

      this.$fetch("/attence-api/blade-user/getUserFlowRoleList", {}).then(res => {
        const data = res.data;
        this.roleList = [];
        data.forEach((v) => {
          if (v.roleFlow != undefined && v.roleFlow != "") {
            const flowLit = v.roleFlow.split("|");
            flowLit.forEach((flow) => {
              if (this.modelKey == flow) {
                this.roleList.push(v);
              }
            });
          }
        });
        if (this.roleList.length > 0) {
          if (this.roleList.length > 1) {//流程发起角色大于1个选择角色发起流程
            this.roleRadio = this.roleList[0].roleAlias;
            this.choseRoleId = this.roleList[0].roleAlias;
            this.roleShow = true;
          } else {
            this.choseRoleId = this.roleList[0].roleAlias;
            this.showProcessInfo();
          }
        } else {
          Toast('未配置流程发起角色，请联系统系管理员！');
        }
      });
    },
    roleCommit() {
      this.choseRoleId = this.roleRadio;
      this.showProcessInfo();
    },
    choseRoleSubmit() {
      const params = {
        id: this.holidayCancelId,
        beginTime: this.beginTime,
        endTime: this.endTime,
        leaveId: this.selectHolidayId,
        reason: this.reason,
        allFiles: this.allFiles,
        appNo: this.appNo,
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
      };
      //流程参数
      params.flow = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
        variables: {
          auditStatus: '',
        }
      };
      params.selectedRole = this.choseRoleId;
      this.$bodyPost("/attence-api/blade-holiday-cancel/holidayCancel/start-process", params).then(resp => {
        const data = resp.data;
        Toast('流程提交成功');
        this.roleShow = false;
        this.processShow = true;
        this.jumpPage();
      });
    },
    jumpPage() {
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/holidayCancel/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    showProcessInfo() {
      //展示对话框
      this.$refs.showProcessDialog.showProcessInfo();
      this.roleShow = false;
    },
    submitFlowMethod() {
      this.choseRoleSubmit();
    },
    getFlowParamsMethod() {
      //用于对话框展示请求接口参数
      const params = {
        businessId: "",
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        flag: 'ok',
        processDefinitionKey: this.modelKey,
        variables: {
          auditStatus: " ",
          selectedRole: this.choseRoleId,
        },
      };

      return params;
    },
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

.login-form-top {
  margin-top: 0px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/holidayCancel/form.vue